import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';

import ActionTypes from './constants';
import { BackOfficeDeviceState } from './types';

export const initialState: BackOfficeDeviceState = null;

function backOfficeDeviceReducer(
  state: BackOfficeDeviceState = initialState,
  action: ApplicationActions
): BackOfficeDeviceState {
  switch (action.type) {
    case ActionTypes.SET_BACK_OFFICE_DEVICE: {
      return action.payload;
    }
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default backOfficeDeviceReducer;
